// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3fogA","col":"CardReaderDesc_col__3Le_C","label":"CardReaderDesc_label__dO4oZ"};